export const S_AXIS_SYSTEM_INTRO = {
    ko: {
        serotonin: {
            title: "세로토닌 시스템: 평정심을 지키는 ‘심리적 방파제’",
            desc: "여기서 말하는 ‘세로토닌 시스템’은 의학적 진단이 아니라, 스트레스가 들어왔을 때 감정 파형을 완충하고 원상복구하는 ‘회복 루틴’을 비유적으로 표현합니다. 자극을 ‘위협’이 아니라 ‘처리할 정보’로 바꾸는 능력이 강할수록, 흔들림이 적고 회복이 빠릅니다.",
            strong: "강한 사람은 감정이 올라와도 금방 안정권으로 돌아오고, 갈등을 ‘정리 가능한 문제’로 재구성합니다. 상대에게는 ‘기복 없는 사람’이라는 신뢰를 줍니다.",
            love: "단, 상대가 ‘해결’보다 ‘정서적 동행’을 원할 때는 반응이 담백해 보일 수 있습니다. 이 축이 강할수록 ‘공감 문장’을 의도적으로 먼저 출력하는 것이 관계 품질을 올립니다."
        },
        dopamine: {
            title: "도파민 시스템: 에너지를 분출하는 ‘심리적 액셀러레이터’",
            desc: "여기서 말하는 ‘도파민 시스템’은 자극·보상·성취에 반응해 행동을 촉진하는 ‘추진력 패턴’의 비유입니다. 기대와 현실의 간격이 커질수록 감정이 빠르게 치솟고, ‘지금 당장’ 해결하거나 움직이려는 충동이 커집니다.",
            strong: "강한 사람은 반응 속도가 빠르고, 연애에서도 속도감 있는 애정 표현과 돌파력으로 매력을 발휘합니다. 관계를 ‘진행’시키는 엔진입니다.",
            love: "다만 갈등에서는 감정이 먼저 튀고 정리가 늦게 오는 패턴이 생길 수 있습니다. 그래서 도파민 축이 강할수록 ‘쿨다운/재접속’ 루틴이 필수입니다."
        }
    },
    en: {
        serotonin: {
            title: "Serotonin System: The ‘Psychological Seawall’ for Composure",
            desc: "In this framework, the ‘serotonin system’ is not a medical claim. It’s a metaphor for your recovery routine: how you buffer emotional spikes and return to baseline after stress. The stronger it is, the more you reframe stimuli as manageable information rather than threats.",
            strong: "When strong, you stabilize quickly and reconstruct conflicts into solvable problems. Partners often experience you as reliable and steady.",
            love: "However, when your partner needs emotional companionship rather than solutions, you may seem flat or distant. The patch is simple: intentionally output validation before analysis."
        },
        dopamine: {
            title: "Dopamine System: The ‘Psychological Accelerator’ for Drive",
            desc: "Here, the ‘dopamine system’ is a metaphor for your action-driving pattern—how you respond to stimulation, reward, and achievement. When expectation gaps widen, urgency rises: you want movement, closure, and resolution now.",
            strong: "When strong, you bring speed, passion, and momentum to relationships. You push things forward.",
            love: "But in conflicts, emotion may sprint ahead of reflection. That’s why a cooldown-and-reconnect routine is essential for high-accelerator types."
        }
    }
};
export const S_AXIS_DATA = {
    ko: {
        1: {
            title: "난공불락의 요새 (The Fortress)",
            summary: "흔들림이 적고 회복이 빠르지만, ‘정서 동행’ 신호가 약해 오해받기 쉬움",
            analysis: `당신은 스트레스를 ‘감정 사건’이 아니라 ‘처리해야 할 상황’으로 분류하는 경향이 강합니다. 
문제가 생겼을 때 마음이 크게 출렁이지 않기 때문에, 주변은 당신을 ‘강한 사람’으로 느낍니다.
다만 강함의 방식이 ‘차분함’이라, 상대의 감정 폭풍 앞에서 당신은 무너지는 대신 ‘고요’로 남습니다.
문제는 그 고요가 상대에게는 “나 혼자 울고 있네”로 번역된다는 점입니다.`,
            triggerMap: [
                "상대가 감정적으로 과격해질 때(울음/격앙/폭발)",
                "논리적 설명 없이 감정만 쏟아낼 때",
                "같은 문제를 반복해서 호소할 때(‘해결 안 되는 이야기’로 인식)"
            ],
            innerMonologue: [
                "“지금 뭘 원하는 거지? 해결? 위로?”",
                "“왜 이렇게까지 크게 반응하지?”",
                "“일단 진정하고 말하면 해결될 텐데…”"
            ],
            relationshipLoop: "상대가 감정 호소 → 나는 해결/정리 모드 → 상대는 외로움/무시로 해석 → 더 강한 감정 출력 → 나는 더 차분해짐(거리감 증가)",
            whatYouNeed: [
                "‘공감은 기술’이라는 관점(감정이 안 느껴져도 출력은 가능)",
                "해결보다 먼저 ‘정서적 인정’ 한 문장",
                "상대의 감정에 ‘의미’를 부여하는 습관"
            ],
            whatPartnerNeeds: [
                "해결책보다 ‘같이 서 있는 느낌’",
                "말을 끝까지 들어주는 시간",
                "감정이 과해 보여도 ‘정상’으로 인정받는 경험"
            ],
            doDont: {
                do: [
                    "해결 전에 공감 1문장(의무)",
                    "질문을 ‘왜’에서 ‘어느 부분이 힘들었어’로 바꾸기",
                    "손 잡기/옆에 앉기 같은 비언어적 동행"
                ],
                dont: [
                    "‘그게 왜 울 일이야?’류의 평가 질문",
                    "즉시 결론/판단(“그러니까 네가~”)",
                    "상대 감정을 축소(“별일 아니잖아”)"
                ]
            },
            scripts: [
                "“해결은 같이 보자. 근데 일단 많이 힘들었겠다.”",
                "“지금은 이유보다 감정이 먼저구나. 내가 옆에 있을게.”",
                "“어떤 부분이 제일 아팠어? 그걸 먼저 듣고 싶어.”",
                "“내가 차분해 보여도, 너 편이야. 지금은 들어줄게.”"
            ],
            repairProtocol: [
                "1) ‘해결’ 금지 30초: 말 멈추고 옆에 앉기/시선 맞추기",
                "2) 공감 1문장 먼저: “많이 힘들었겠다/속상했겠다”",
                "3) 질문은 1개만: “지금은 위로가 필요해, 해결이 필요해?”",
                "4) 마무리 확언: “나는 네 편이야. 같이 있을게.”"
            ],
            growthPath: "차분함을 ‘무반응’이 아니라 ‘동행 신호’로 바꾸면 완성형이 된다. 해결은 늦어도 되지만, 공감은 늦으면 안 된다.",
            loveInsight: "당신의 평온은 강력하지만, 사랑은 가끔 ‘같이 흔들려 주는 신호’로 유지된다."
        },

        2: {
            title: "균열 있는 방파제 (The Leaky Barrier)",
            summary: "사람에겐 안정적이지만 환경 과부하에서 급격히 날카로워지는 조건부 안정형",
            analysis: `당신은 ‘사람 문제’는 잘 견디는데, ‘환경 자극(소음/혼잡/대기/촉감)’이 누적되면 급격히 에너지가 고갈됩니다.
이때 당신의 짜증은 상대를 향한 감정이 아니라, 시스템 과열에 대한 경보입니다.
하지만 연애에서는 원인(환경)과 결과(말투/표정)가 분리되지 않아서, 옆에 있는 사람이 맞는 구조가 됩니다.`,
            triggerMap: [
                "시끄러운 식당/카페, 교통체증, 장시간 대기",
                "통제 불가능한 상황(예약 실패, 줄 서기, 계획 틀어짐)",
                "배고픔/수면 부족 상태에서 추가 자극"
            ],
            innerMonologue: [
                "“여기 너무 시끄러워… 숨이 막혀.”",
                "“이걸 왜 이렇게 비효율적으로 하지?”",
                "“지금 빨리 빠져나가고 싶다.”"
            ],
            relationshipLoop: "처음엔 다정함 → 환경 자극 누적 → 말투/표정 경직 → 상대는 ‘내가 문제인가’ → 오해로 갈등 → 나는 더 피곤해짐",
            whatYouNeed: [
                "환경 설계(코스, 자리, 시간대) = 관계 품질",
                "‘과부하 신호’를 미리 말하는 능력",
                "컨디션 관리(배고픔/수면)도 연애 스킬로 인정"
            ],
            whatPartnerNeeds: [
                "‘너 때문이 아니다’라는 명확한 분리 설명",
                "쉬는 구간(카페/차 안/조용한 곳) 확보",
                "갑작스러운 태도 변화에 대한 예고"
            ],
            doDont: {
                do: [
                    "20% 배터리 룰: 떨어지기 전에 말하기",
                    "환경 탓을 ‘설명’으로 전환(핑계처럼 들리지 않게)",
                    "자극 큰 날은 일정 단순화"
                ],
                dont: [
                    "무표정+침묵으로 버티기(오해 폭발)",
                    "상대에게 짜증을 ‘방출’",
                    "‘이 정도도 못 참아?’라고 스스로를 몰아세움"
                ]
            },
            scripts: [
                "“지금 환경이 자극적이라 예민해질 것 같아. 10분만 쉬자.”",
                "“너한테 화난 게 아니라, 내 시스템이 과부하야.”",
                "“조용한 데로 옮기면 다시 괜찮아질 거야.”",
                "“내가 말투가 딱딱해지면 지금이 과부하 신호야.”"
            ],
            repairProtocol: [
                "1) 과부하 선언: “지금 환경 때문에 예민해질 것 같아”",
                "2) 즉시 리셋: 장소 이동/소리 줄이기/물 한 모금",
                "3) 분리 문장: “너 때문이 아니라 환경 때문이야”",
                "4) 상대 케어 1문장: “서운했지? 내가 미리 말했어야 했어”"
            ],
            growthPath: "참는 게 아니라 ‘환경을 설계하고 미리 알리는 사람’이 되면 된다. 예고만 잘해도 오해의 70%가 사라진다.",
            loveInsight: "당신은 변덕이 아니라 전력 관리가 필요한 고성능 시스템이다."
        },

        3: {
            title: "침묵의 적립자 (The Silent Collector)",
            summary: "겉은 조용하지만 속에서 ‘장부’를 쓰는 내면 정산형",
            analysis: `당신은 갈등이 생기면 즉시 감정을 풀기보다, 혼자서 상황을 재구성합니다.
표면적으로는 조용하지만 내부에서는 “이 말은 왜 했지?”, “패턴이 또 반복됐네” 같은 정산이 돌아갑니다.
그래서 당신의 ‘알았어’는 용서가 아니라 ‘보류’일 수 있습니다.
상대가 이걸 모르면, 어느 날 갑자기 관계 종료를 통보받는 느낌을 받습니다.`,
            triggerMap: [
                "상대가 사과 없이 넘어가려 할 때",
                "같은 문제가 반복될 때",
                "내가 존중받지 못한다고 느낄 때(말투/무시/약속)"
            ],
            innerMonologue: [
                "“지금 말해봐야 싸움만 커져.”",
                "“일단 저장해두자.”",
                "“이게 또 반복되면 끝이야.”"
            ],
            relationshipLoop: "갈등 → 침묵/정리 → 겉상 종료 → 내부 적립 → 임계점 → 대화 없이 종료/냉각",
            whatYouNeed: [
                "‘소액 결제’처럼 서운함을 짧게 처리하는 루틴",
                "종료 신호를 명확히(진짜 끝 vs 보류)",
                "상대가 이해할 수 있게 ‘프로세스 공유’"
            ],
            whatPartnerNeeds: [
                "침묵이 ‘무시’가 아니라 ‘정리’라는 안내",
                "다시 대화할 ‘약속된 시간’",
                "쌓이기 전에 작은 피드백"
            ],
            doDont: {
                do: [
                    "“지금은 보류, ○시에 재개”를 말로 박기",
                    "서운함 1~2개만 핵심으로 말하기",
                    "상대가 고칠 수 있는 ‘요청’ 형태로 전달"
                ],
                dont: [
                    "‘괜찮아’로 덮고 장부에만 적립",
                    "임계점에서 단칼에 끝내기",
                    "상대가 모르는 ‘감점 시스템’ 운용"
                ]
            },
            scripts: [
                "“지금은 정리 시간이 필요해. 내일 9시에 다시 이야기하자.”",
                "“아까 그 말이 서운했어. 다음엔 그렇게 말하지 말아줘.”",
                "“나는 쌓이면 한 번에 무너져서, 작게라도 지금 말할게.”",
                "“괜찮은 게 아니라 보류야. 다시 얘기해야 풀려.”"
            ],
            repairProtocol: [
                "1) 침묵 전 신호 주기: “정리 시간 필요해. 조금 이따 다시 얘기하자”",
                "2) 장부 대신 ‘소액 결제’: 서운함 1개만 짧게 말하기",
                "3) 상대 확인: “내 말이 너무 차갑게 들렸어?”",
                "4) 재발 방지 한 줄: “다음엔 그때그때 말할게”"
            ],
            growthPath: "침묵은 강점이지만 ‘예고 없는 침묵’은 폭탄이다. 말하기를 작게 자주 하면, 이별 통보가 대화로 바뀐다.",
            loveInsight: "침묵은 평화가 아니라 지연된 정산이다. 장부를 숨기면 관계는 갑자기 끝난다."
        },

        4: {
            title: "유연한 완충재 (The Flexible Buffer)",
            summary: "재해석이 빠르고 회복이 좋지만 ‘직면’을 건너뛰면 반복 갈등이 생김",
            analysis: `당신은 불편한 사건을 빠르게 가볍게 만드는 재능이 있습니다.
그래서 관계의 분위기를 살리고, 큰 싸움을 막는 능력이 뛰어납니다.
하지만 ‘넘김’이 습관이 되면, 해결되지 않은 핵심이 누적되어 같은 싸움이 반복됩니다.
상대는 어느 순간 “대화가 안 되는 사람”이라고 느낄 수 있습니다.`,
            triggerMap: [
                "상대가 진지하게 대화하려 할 때(나는 무겁다고 느낌)",
                "갈등의 핵심이 ‘감정’일 때(논리로 못 끝냄)",
                "상대가 반복적으로 ‘그건 넘길 문제가 아니야’라고 말할 때"
            ],
            innerMonologue: [
                "“그냥 좋게 넘어가면 되잖아.”",
                "“이걸 왜 이렇게 무겁게 하지?”",
                "“지금 분위기 망치기 싫어.”"
            ],
            relationshipLoop: "불편 사건 → 유머/재해석 → 단기 평화 → 핵심 미해결 → 재발 → 상대의 좌절 증가",
            whatYouNeed: ["‘웃고 넘김’과 ‘정리’의 균형", "진지 모드 슬롯(주1회)", "상대의 니즈(공감/해결) 확인"],
            whatPartnerNeeds: ["진짜로 다뤄지는 경험", "회피가 아니라 ‘선택적 유머’라는 설명", "합의/재발방지"],
            doDont: {
                do: ["유머 후 합의(“그래서 다음엔 어떻게 할까?”)", "상대가 중요하단 걸 인정", "반복 문제는 반드시 문서화(합의)"],
                dont: ["‘좋은 게 좋은 거지’로 종료", "상대의 진지함을 과민으로 평가", "직면을 계속 미룸"]
            },
            scripts: [
                "“이번 건 웃고 넘기기보다 정리하자.”",
                "“지금은 해결이 필요해? 아니면 들어주면 돼?”",
                "“좋게 보려는 건 맞아. 근데 반복은 막고 싶어.”"
            ],
            repairProtocol: [
                "1) 유머 잠깐 중지: “이번 건은 웃고 넘기기 어려워”",
                "2) 상대 감정 인정: “너한텐 중요한 문제구나”",
                "3) 합의 1개 만들기: “다음엔 ○○로 하자”",
                "4) 끝맺음: “좋게 넘기려는 마음도, 바꾸려는 마음도 둘 다 있어”"
            ],
            growthPath: "긍정은 유지하되 ‘한 번은 정리하고 넘어가기’가 핵심이다. 웃음 다음에 합의가 붙으면 최고의 안정기가 된다.",
            loveInsight: "긍정은 비타민이지만, 상대의 고통을 축소하면 독이 된다."
        },

        5: {
            title: "열정적인 스프린터 (The Passionate Sprinter)",
            summary: "즉각 반응·즉각 해결형. 속도는 매력, 과열은 위험",
            analysis: `당신은 미결 상태를 견디기 어렵고, 관계를 ‘진행’시키려는 힘이 강합니다.
그래서 사랑은 뜨겁고 빠르게 전개됩니다.
하지만 갈등에서 과열되면 ‘정확한 말’이 아니라 ‘강한 말’이 먼저 나와 상대의 취약점을 타격할 수 있습니다.
본인은 빠르게 사과해도 상대의 상처는 오래 남습니다.`,
            triggerMap: ["답장 지연", "미결/애매한 상태", "내가 무시당한다고 느낄 때"],
            innerMonologue: ["“지금 당장 정리해야 돼.”", "“왜 답이 없어?”", "“이게 말이 돼?”"],
            relationshipLoop: "불안/분노 상승 → 강한 말/돌파 → 빠른 사과 → 상대는 아직 회복 전 → 재발",
            whatYouNeed: ["쿨다운 규칙", "금지어/금지주제 리스트", "느린 대화 루틴"],
            whatPartnerNeeds: ["상처 방지(말투)", "회복 시간", "과열 시 멈춤 신호"],
            doDont: { do: ["10분 쿨다운", "‘안전 먼저’ 선언", "사과 후 케어"], dont: ["약점 공격", "결론 강요", "‘나는 풀렸는데’ 금기"] },
            scripts: [
                "“지금 과열이라 말이 세질 것 같아. 10분만 있다가 다시.”",
                "“결론보다 안전이 먼저야. 상처 주는 말은 안 할게.”",
                "“내가 급해졌어. 너 마음부터 회복하게 해줄게.”"
            ],
            repairProtocol: [
                "1) 쿨다운 선언 10분: “지금 과열이라 말이 세질 것 같아”",
                "2) 금지어/금지주제 ON: 약점·과거 소환 금지",
                "3) 재접속: “지금은 안전이 먼저야” 1문장",
                "4) 사과+케어: “방금 과했어. 회복할 시간 줄게”"
            ],
            growthPath: "속도는 장점이지만 ‘멈출 줄 아는 속도’가 진짜 실력이다. 10분 멈춤을 습관화하면 관계 사고가 급감한다.",
            loveInsight: "속도는 전진시키지만, 방향 없는 속도는 폐차시킨다."
        },

        6: {
            title: "고감도 센서 기기 (The High-Sensitivity Sensor)",
            summary: "감각 과부하가 빠르다. ‘절전 모드’를 공유하면 오해가 줄어든다",
            analysis: `당신은 자극을 크게 받아들이는 고해상도 타입입니다.
그래서 디테일을 잘 느끼고, 상대의 변화도 빨리 캐치합니다.
하지만 동시에 배터리가 빨리 닳아, 과부하 시 말이 줄고 표정이 굳습니다.
의도는 ‘무관심’이 아니라 ‘보존’인데, 상대는 ‘변심’으로 오해합니다.`,
            triggerMap: ["시끄러운 공간", "장시간 이동", "사람 많은 곳", "연속 일정"],
            innerMonologue: ["“너무 많아… 지금은 입력이 과해.”", "“지금은 말할 에너지가 없어.”"],
            relationshipLoop: "자극 누적 → 절전 → 상대 오해(서운) → 추가 감정 요구 → 더 절전",
            whatYouNeed: ["저자극 설계", "회복 구간", "20% 미리 알림"],
            whatPartnerNeeds: ["오해 방지 설명", "쉬는 시간 존중", "‘다시 돌아올’ 확신"],
            doDont: { do: ["과부하 선언", "짧은 휴식", "회복 후 재접속"], dont: ["무언으로 버티기", "자기 탓 과잉", "상대 감정 무시"] },
            scripts: [
                "“지금 자극이 많아서 에너지가 떨어지고 있어. 잠깐 쉬자.”",
                "“너 때문이 아니라 입력이 과해. 회복하면 다시 괜찮아져.”",
                "“조용한 구간이 있어야 오래 즐길 수 있어.”"
            ],
            repairProtocol: [
                "1) 배터리 알림(20%): “지금 자극이 과해서 에너지가 떨어져”",
                "2) 저자극 리셋: 조용한 곳/짧은 산책/물",
                "3) 오해 차단: “재미없어서가 아니라 과부하야”",
                "4) 재접속 약속: “15분만 쉬고 다시 같이 하자”"
            ],
            growthPath: "민감함은 결함이 아니라 고성능이다. ‘사용 설명서(과부하 신호+리셋 루틴)’를 공유하면 갈등이 장점으로 바뀐다.",
            loveInsight: "고장 난 게 아니라 고해상도다. 관리가 곧 실력이다."
        },

        7: {
            title: "냉정한 저격수 (The Cold Sniper)",
            summary: "분노가 논리로 우회해 ‘정밀 타격’이 된다. 이기면 질수록 관계가 무너질 수 있음",
            analysis: `당신은 감정 폭발보다 ‘언어의 정확성’이 먼저 작동합니다.
갈등은 감정 공유가 아니라 ‘논리적 판정’처럼 느껴집니다.
그래서 상대의 모순을 빠르게 찾아내고, 빈틈 없이 정리합니다.
문제는 상대의 자존감이 관계의 기반일 때, 당신의 정확함이 ‘심판’으로 느껴진다는 점입니다.`,
            triggerMap: ["상대가 말을 바꿀 때", "책임 회피", "논리 비약", "거짓말/숨김"],
            innerMonologue: ["“지금 말이 안 맞아.”", "“팩트부터 정리하자.”"],
            relationshipLoop: "상대 감정 호소 → 나는 논리로 반박 → 상대 위축/폭발 → 나는 더 냉정 → 관계 안전도 하락",
            whatYouNeed: ["‘승리’가 목표가 아님을 상기", "공감 버퍼 1문장", "금지무기(과거/약점)"],
            whatPartnerNeeds: ["안전한 분위기", "틀려도 존중받는 경험", "감정 인정"],
            doDont: { do: ["공감 먼저", "목표 선언(안전)", "오늘 문제만"], dont: ["과거 소환", "자존감 타격", "말문 막기"] },
            scripts: [
                "“맞고 틀리고보다, 너 마음이 다치지 않게 말할게.”",
                "“속상했겠다. 그 다음에 내 입장 말해도 돼?”",
                "“오늘 일만 보자. 과거는 무기화하지 말자.”"
            ],
            repairProtocol: [
                "1) 공감 1회 의무: “속상했겠다”를 먼저 말하기",
                "2) 목표 선언: “이기려는 게 아니라 안전하게 말하려는 거야”",
                "3) 오늘 문제만: 과거/인신공격 금지",
                "4) 종료 체크: “지금 이 대화, 너한테 안전했어?”"
            ],
            growthPath: "정확함을 칼이 아니라 지도처럼 쓰면 된다. 공감 1문장만 추가해도 ‘심판’이 ‘리더’로 바뀐다.",
            loveInsight: "팩트는 맞아도, 사랑은 마음의 안전으로 기억된다."
        },

        8: {
            title: "드라마틱 롤러코스터 (The Dramatic Rollercoaster)",
            summary: "감정 진폭이 크고 회복이 빠르다. ‘속도 차’가 관계를 지치게 함",
            analysis: `당신은 감정의 피크가 높고 전환이 빠릅니다.
본인은 뒤끝이 없다고 느끼지만, 상대는 방금의 충격에서 아직 나오지 못했을 수 있습니다.
그래서 반복되면 상대는 ‘정서적 멀미’를 겪고 안전을 위해 거리를 둡니다.`,
            triggerMap: ["사소한 무시", "기대 불일치", "즉흥적 자극", "피곤한 상태"],
            innerMonologue: ["“지금 너무 서운해!”", "“아냐 괜찮아(갑자기 리셋)”"],
            relationshipLoop: "폭발 → 리셋 → 상대 미회복 → 재폭발",
            whatYouNeed: ["피크 감쇄 루틴", "상대 회복 속도 존중", "사후 케어"],
            whatPartnerNeeds: ["안정", "회복 시간", "다시 안전해질 수 있는 말"],
            doDont: { do: ["카운트/호흡", "사과+케어", "속도 맞추기"], dont: ["‘왜 아직도 그래?’", "사과 후 방치", "반복 패턴 부정"] },
            scripts: [
                "“나는 좀 가라앉았는데 너는 아닐 수 있지. 기다릴게.”",
                "“방금 말은 과했어. 네가 안전해질 때까지 할게.”",
                "“지금은 해결보다 안정부터 만들자.”"
            ],
            repairProtocol: [
                "1) 피크 감쇄(10초): 숫자 세기/호흡",
                "2) 사과는 즉시, 변명은 금지",
                "3) 속도 맞추기: “나는 풀렸어도 너는 아닐 수 있어”",
                "4) 회복 시간 제공: 대화 재개 시간 합의"
            ],
            growthPath: "감정 에너지는 자원이다. 진폭을 10%만 줄이고, 회복 속도를 상대에 맞추면 드라마가 로맨스로 바뀐다.",
            loveInsight: "번개는 지나가도, 상대의 마음에는 흔적이 남는다."
        },

        9: {
            title: "얼어붙은 화산 (The Frozen Volcano)",
            summary: "참는 습관이 강해 내부 압력이 쌓인다. 작은 계기에서 큰 폭발 위험",
            analysis: `당신은 분노가 없어서 참는 게 아니라, ‘참는 방식’이 익숙합니다.
그래서 평소엔 안정적이지만, 배출구가 막히면 압력이 올라가 사소한 계기에서 폭발할 수 있습니다.
상대는 ‘왜 이 정도에?’라고 느끼며 공포를 경험할 수 있습니다.`,
            triggerMap: ["반복되는 작은 무시", "정리/약속 관련 디테일", "피곤 누적"],
            innerMonologue: ["“넘기자…”, “또 반복이네…”, “이제 한계야.”"],
            relationshipLoop: "누적 → 임계점 → 폭발 → 자책/침잠",
            whatYouNeed: ["안전 밸브(자주 말하기)", "감정 단계 낮춰 공유", "트리거 합의"],
            whatPartnerNeeds: ["예측 가능성", "작은 피드백", "폭발 전 신호"],
            doDont: { do: ["주2회 소액 공유", "불편 단계에서 말하기", "휴식"], dont: ["무한 참기", "폭발 후 설명만", "자기 혐오"] },
            scripts: [
                "“화까지는 아닌데 불편했어. 다음엔 이렇게 해줄래?”",
                "“나는 쌓이면 터져서, 지금 말해두는 게 좋아.”",
                "“작게 말할게. 나중에 크게 되는 걸 막고 싶어.”"
            ],
            repairProtocol: [
                "1) 폭발 전 신호: “나 지금 쌓이고 있어”",
                "2) 불편 단계에서 말하기(화까지 가지 않기)",
                "3) 작은 요청 1개: “다음엔 ○○만 바꿔줘”",
                "4) 휴식/리셋 후 재접속: ‘지금은 멈춤→다시 대화’"
            ],
            growthPath: "참는 능력은 이미 충분하다. 이제는 ‘작게 배출’하는 능력을 추가하면 가장 안정적인 타입이 된다.",
            loveInsight: "참는 건 미덕이 아니라 누적일 수 있다."
        },

        10: {
            title: "유리 멘탈 해결사 (The Glass Fixer)",
            summary: "상처는 크게 받지만 관계를 살리려 먼저 수습하는 헌신형",
            analysis: `당신은 타격감이 크면서도, 관계 붕괴를 더 두려워해 수습 행동이 먼저 나옵니다.
그래서 연인은 당신에게 기대기 쉬워지고, 당신은 조용히 방전됩니다.
‘나는 괜찮아’가 사실은 ‘나는 지금도 깨지고 있어’일 수 있습니다.`,
            triggerMap: ["갈등 조짐", "상대가 힘들어할 때", "관계가 깨질 것 같은 신호"],
            innerMonologue: ["“일단 수습하자.”", "“내가 참으면 넘어가.”", "“내가 부족해서 그래.”"],
            relationshipLoop: "수습/사과 → 단기 안정 → 내 방전 → 갑작스런 탈진/거리",
            whatYouNeed: ["수습 전 상태 공유", "역할 분담", "회복 시간"],
            whatPartnerNeeds: ["너도 힘들다는 사실", "기댈 수 있는 방식 합의", "희생이 아닌 협력"],
            doDont: { do: ["먼저 고백", "짐 나누기", "회복 시간 확보"], dont: ["혼자 다 떠안기", "천사 역할", "방전 후 잠수"] },
            scripts: [
                "“나도 상처받았어. 우리 둘이 같이 정리하자.”",
                "“내가 다 수습하면 내일 내가 무너질 것 같아. 나눠서 하자.”",
                "“지금은 회복이 필요해. 30분 후에 다시 얘기하자.”"
            ],
            repairProtocol: [
                "1) 수습 전에 상태 말하기: “나도 상처받았어”",
                "2) 역할 분담: “이건 너/이건 나”로 나누기",
                "3) 회복 시간 확보: “30분만 쉬고 다시 얘기하자”",
                "4) 재발 방지: ‘수습 혼자 하지 않기’ 합의"
            ],
            growthPath: "헌신을 줄이라는 게 아니라 ‘짐을 나누는 헌신’으로 바꾸라는 뜻이다. 약함을 공유하면 관계가 오래 간다.",
            loveInsight: "부서진 배를 혼자 수리하면 결국 침몰한다."
        },

        11: {
            title: "방관하는 도인 (The Bystander)",
            summary: "갈등에서 감정 개입이 낮아 ‘거리두기’가 자동으로 켜지는 분리형",
            analysis: `당신은 갈등이 오면 감정에 휩쓸리지 않으려 자동으로 거리를 둡니다.
본인에게는 평화지만, 상대에게는 “나 혼자 싸우네”라는 고립이 됩니다.
무반응은 의도치 않게 강한 메시지가 됩니다.`,
            triggerMap: ["큰 감정 충돌", "소리/격앙", "감정 요구가 강할 때"],
            innerMonologue: ["“이걸 왜 이렇게까지…”", "“난 지금 말하면 더 망쳐.”"],
            relationshipLoop: "상대 감정 출력 → 나는 거리두기 → 상대는 더 세게 호소 → 나는 더 분리",
            whatYouNeed: ["존재 표시 스킬", "대화 재개 시간 약속", "영향 인정"],
            whatPartnerNeeds: ["혼자 두지 않는다는 신호", "짧은 반응", "다시 돌아올 약속"],
            doDont: { do: ["‘나는 여기 있어’ 출력", "시간 약속", "영향 인정"], dont: ["무한 침묵", "도망", "상대 감정 무시"] },
            scripts: [
                "“지금 당장 해결은 어렵지만, 너 혼자 두진 않을게.”",
                "“너 화가 나니 나도 불편하고 긴장돼. 같이 보자.”",
                "“지금은 정리할 시간 필요해. 오늘 10시에 다시 얘기하자.”"
            ],
            repairProtocol: [
                "1) 존재 표시 1문장: “나 여기 있어”",
                "2) 대화 시간 약속: “지금은 정리하고 잠시 뒤에 다시 얘기하자”",
                "3) 영향 인정: “네 감정이 나에게도 영향을 줘”",
                "4) 재접속: 짧은 공감 + 다음 행동 1개"
            ],
            growthPath: "방관을 ‘구조화된 거리두기’로 바꾸면 된다. 사라지지 말고, 돌아올 시간을 약속하는 순간 관계는 안전해진다.",
            loveInsight: "싸우지 않는 게 사랑이 아니라, 함께 서주는 게 사랑일 때가 있다."
        },

        12: {
            title: "전략적 인내자 (The Strategic Endurer)",
            summary: "감정은 있지만 출력은 관리한다. 완벽함이 ‘가짜’로 보일 위험",
            analysis: `당신은 감정이 올라와도 ‘지금 이걸 표출하면 관계에 이득인가?’를 먼저 계산합니다.
그래서 매너 있고 안정적인 연애를 만들 수 있지만,
상대는 “이 사람이 진짜로 느끼긴 하나?”라는 불안을 가질 수 있습니다.
빈틈이 없으면 친밀감이 자라기 어렵습니다.`,
            triggerMap: ["비효율적 감정 싸움", "감정 소모가 크다고 느낄 때", "상대가 즉흥적으로 몰아붙일 때"],
            innerMonologue: ["“지금 화내면 손해야.”", "“관리하자.”"],
            relationshipLoop: "나는 침착 유지 → 상대는 진심 의심 → 더 강한 감정 요구 → 나는 더 관리",
            whatYouNeed: ["날것 5% 공개", "동기 설명(지키려는 조절)", "상대 감정 수용"],
            whatPartnerNeeds: ["인간미", "취약함", "‘나도 중요하다’는 체감"],
            doDont: { do: ["서툰 감정 한 번 보여주기", "사랑 때문에 조절한다 명시", "상대 감정 먼저 수용"], dont: ["항상 완벽", "반박 먼저", "운영 모드 고정"] },
            scripts: [
                "“나는 운영하려는 게 아니라 지키려고 조절하는 거야.”",
                "“오늘은 계산 말고 그냥 말할래. 나 서운했어.”",
                "“지금은 네 감정이 먼저야. 내 논리는 잠깐 뒤로 둘게.”"
            ],
            repairProtocol: [
                "1) 감정 1줄 공개: “나도 서운했어/나도 불편했어”",
                "2) 의도 설명: “관리하려는 게 아니라 지키려는 조절이야”",
                "3) 상대 감정 먼저 수용(반박 금지)",
                "4) 작은 변화 1개 합의(너무 완벽하게 하지 않기)"
            ],
            growthPath: "완벽함을 5%만 내려놓으면 친밀감이 폭발한다. 계산기를 잠깐 내려두는 용기가 관계를 깊게 만든다.",
            loveInsight: "사랑은 때로 계산을 내려놓을 때 깊어진다."
        }
    },

    // EN is matched to the same detailed depth (condensed but still premium-detailed)
    en: {
        1: {
            title: "The Fortress",
            summary: "Ultra-stable and fast to recover—yet easily misread as emotionally distant",
            analysis: `You instinctively classify stress as “manageable information” rather than an emotional event. 
People experience you as strong because you don’t visibly shake. The downside: in your partner’s storm, you remain calm—so calm that it can translate as “I’m alone in this.”`,
            triggerMap: [
                "Partner crying or escalating emotionally",
                "Emotion without a clear explanation or logic",
                "Repeating the same emotional complaint (feels ‘unsolvable’)"
            ],
            innerMonologue: [
                "“What do they want—comfort or solutions?”",
                "“Why is this so intense?”",
                "“If we calm down, we can fix it.”"
            ],
            relationshipLoop: "Partner escalates → you go into solution/analysis → partner feels unseen → escalates more → you become calmer (distance grows)",
            whatYouNeed: [
                "Treat empathy as a skill (output is possible even if you don’t ‘feel’ it strongly)",
                "Mandatory validation before solutions",
                "Practice granting meaning to emotions, not just facts"
            ],
            whatPartnerNeeds: [
                "A visible signal of companionship",
                "Time to be heard fully",
                "Validation that their intensity is ‘allowed’"
            ],
            doDont: {
                do: ["Validate first", "Ask “what part hurt most?”", "Use nonverbal support (sit closer, hold hands)"],
                dont: ["“Why are you crying?” framing", "Instant verdicts", "Minimizing feelings"]
            },
            scripts: [
                "“We’ll solve it together—first, that sounds really hard.”",
                "“No need to explain yet. I’m here with you.”",
                "“Which part hurt the most? Start there.”"
            ],
            repairProtocol: [
                "1) No solutions for 30 seconds: sit close, eye contact",
                "2) One validation line first",
                "3) Ask one question: comfort or solution?",
                "4) Close with reassurance: “I’m on your side.”"
            ],
            growthPath: "Turn calm into visible companionship. Solutions can wait—validation can’t.",
            loveInsight: "Calm is power—but love sometimes needs visible emotional companionship."
        },

        2: {
            title: "The Leaky Barrier",
            summary: "Stable with people, fragile under sensory overload—environment flips your tone",
            analysis: `You handle “people problems” well, but sensory load (noise, crowds, waiting, heat) drains you fast. 
Your irritation is often an overload alarm, not personal anger—yet the impact lands on the nearest person: your partner.`,
            triggerMap: ["Noisy places, traffic jams, long waiting", "Loss of control (plans collapse)", "Low sleep/hunger + stimulation"],
            innerMonologue: ["“Too loud… I can’t breathe.”", "“This is so inefficient.”", "“I need out—now.”"],
            relationshipLoop: "Warm start → overload accumulates → tone hardens → partner personalizes it → conflict grows → you get even more depleted",
            whatYouNeed: ["Route design is relationship quality", "Early overload disclosure", "Treat sleep/food as relationship skills"],
            whatPartnerNeeds: ["Clear separation: environment ≠ them", "Rest blocks", "Predictability (warnings)"],
            doDont: { do: ["20% battery warning", "Move locations", "Name the cause clearly"], dont: ["Silent suffering", "Dumping irritation onto partner"] },
            scripts: [
                "“I’m getting overstimulated—can we reset for 10 minutes?”",
                "“Not you. The environment is overloading me.”",
                "“If my tone shifts, it’s a battery signal—I’ll warn you early.”"
            ],
            repairProtocol: [
                "1) Declare overload early",
                "2) Reset immediately (move / reduce noise / water)",
                "3) Separate cause: “environment, not you”",
                "4) One care line: “I should’ve warned you earlier.”"
            ],
            growthPath: "Stop enduring—start designing and signaling. Warning early removes most misunderstandings.",
            loveInsight: "You’re not inconsistent—you’re environment-sensitive. Power management prevents misunderstandings."
        },

        3: {
            title: "The Silent Collector",
            summary: "Quiet on the outside, constantly settling accounts on the inside",
            analysis: `When conflict hits, you don’t explode—you withdraw inward. On the surface it looks like calm, but internally you are reconstructing the event frame by frame: what was said, what was meant, what pattern this repeats. 
      Your “Okay” is often not forgiveness—it's a temporary stop signal while your system keeps running. If your partner misreads that silence as closure, the relationship can end with a shock: they feel like they were suddenly deleted without a chance to repair.`,
            triggerMap: [
                "When your partner tries to move on without acknowledging harm",
                "When the same issue repeats (pattern recognition alarm)",
                "When you feel disrespected (tone, dismissal, broken promises)"
            ],
            innerMonologue: [
                "“If I speak now, it’ll only get uglier.”",
                "“I’ll store this and analyze it later.”",
                "“If this repeats again, I’m done.”"
            ],
            relationshipLoop:
                "Conflict → silence + internal analysis → surface-level closure → hidden accumulation → threshold crossing → cold exit / sudden shutdown",
            whatYouNeed: [
                "A ‘micro-settlement’ habit: express small hurts early",
                "Clear status signals: pause vs closure",
                "Process transparency: tell your partner what your silence means"
            ],
            whatPartnerNeeds: [
                "A clear return time (“we’ll talk at 9pm tomorrow”)",
                "Reassurance that silence isn’t contempt",
                "Small feedback before it becomes a final verdict"
            ],
            doDont: {
                do: [
                    "Name the pause and schedule reconnection",
                    "Share 1–2 core issues as: fact → feeling → request",
                    "Use repair language while still calm"
                ],
                dont: [
                    "Say ‘I’m fine’ while secretly recording everything",
                    "Run an invisible ‘deduction system’ your partner can’t see",
                    "End things at the threshold without giving any repair path"
                ]
            },
            scripts: [
                "“I need time to process. Let’s talk tomorrow at 9.”",
                "“That comment hurt me. Next time, please don’t say it that way.”",
                "“If I store things up, I crash later—so I’m saying this now.”",
                "“I’m not okay yet. I’m pausing, not closing.”"
            ],
            repairProtocol: [
                "1) Announce the pause + say when you'll return",
                "2) Share one small hurt (micro-settlement)",
                "3) Check impact: “Did that sound cold to you?”",
                "4) Promise the habit: “I’ll speak earlier next time.”"
            ],
            growthPath: "Silence is strength—unscheduled silence is a bomb. Small, frequent sharing prevents sudden shutdowns.",
            loveInsight:
                "Your silence isn’t peace; it’s delayed settlement. Reveal the ledger before you end the contract."
        },

        4: {
            title: "The Flexible Buffer",
            summary: "Fast reappraisal, fast recovery—risk of skipping real confrontation",
            analysis: `You have a rare talent: you can reduce emotional heat by reframing events quickly. That makes you a stabilizer and a mood-rescuer. 
      But if reframing becomes your default exit, unresolved core issues remain intact beneath the surface. Over time, your partner can feel like they’re hitting a soft wall: everything gets smoothed over, yet nothing truly changes.`,
            triggerMap: [
                "When your partner wants a serious talk and you feel it’s ‘too heavy’",
                "When the core problem is emotional (not logically solvable)",
                "When you hear, “This isn’t something we can just laugh off.”"
            ],
            innerMonologue: [
                "“Let’s not make this a big deal.”",
                "“Why are we making it so heavy?”",
                "“I don’t want to ruin the mood.”"
            ],
            relationshipLoop:
                "Uncomfortable event → humor/reframe → short-term peace → core issue remains → repeats → partner frustration accumulates",
            whatYouNeed: [
                "A balance rule: reframe *and* resolve",
                "A weekly ‘serious mode’ slot",
                "A habit of asking: comfort or solution?"
            ],
            whatPartnerNeeds: [
                "The experience of being truly addressed",
                "A clear signal that you’re not avoiding them",
                "Concrete agreements to prevent repetition"
            ],
            doDont: {
                do: [
                    "Use humor, then switch to: “So what do we do next?”",
                    "Validate that it matters to them, even if it doesn’t to you",
                    "Write one concrete agreement for recurring issues"
                ],
                dont: [
                    "End with “Let’s just get along” as the whole solution",
                    "Label their seriousness as ‘overreacting’",
                    "Delay confrontation until resentment builds"
                ]
            },
            scripts: [
                "“I want to laugh it off, but this one deserves a real talk.”",
                "“Do you need comfort right now—or solutions?”",
                "“I’m staying positive, but I don’t want this to repeat.”"
            ],
            repairProtocol: [
                "1) Pause humor: “This one needs a real talk.”",
                "2) Validate: “This matters to you.”",
                "3) Make one agreement for next time",
                "4) Close: “I want both peace and change.”"
            ],
            growthPath: "Keep optimism, add one real agreement. Humor + clarity becomes elite stability.",
            loveInsight:
                "Positivity is a vitamin—unless it shrinks your partner’s pain into invisibility."
        },

        5: {
            title: "The Passionate Sprinter",
            summary: "Immediate reaction + urgent resolution—speed is charm, overheating is risk",
            analysis: `You hate unresolved states. Ambiguity feels like physical discomfort, so you push toward closure fast. In love, this creates momentum and intensity—people feel chosen, pursued, and prioritized. 
      The danger is heat: when you’re flooded, you can output strong words before your brakes engage. You may cool down quickly, but your partner may still be bleeding from the language.`,
            triggerMap: [
                "Late replies / delayed closure",
                "Ambiguous relationship signals",
                "Feeling ignored, blocked, or ‘not taken seriously’"
            ],
            innerMonologue: [
                "“We need to fix this right now.”",
                "“Why is there no answer?”",
                "“This doesn’t make sense—say it clearly.”"
            ],
            relationshipLoop:
                "Urgency spike → force closure → harsh output → quick apology → partner still hurt → repeat under the next delay",
            whatYouNeed: [
                "A fixed cooldown rule (time + distance)",
                "A ‘no-weapons list’ (weak spots, past mistakes, identity attacks)",
                "A slower conversation rhythm for conflict"
            ],
            whatPartnerNeeds: [
                "Safety from cutting language",
                "Time to recover after impact",
                "A clear stop-signal when you’re overheating"
            ],
            doDont: {
                do: [
                    "Use a 10-minute cooldown before continuing",
                    "Say “Safety first, closure second” out loud",
                    "After apologizing, provide aftercare (time + reassurance)"
                ],
                dont: [
                    "Strike weak spots to ‘win’ fast",
                    "Demand immediate conclusions while they’re dysregulated",
                    "Say “I’m fine now, why aren’t you?” (absolute ban)"
                ]
            },
            scripts: [
                "“I’m overheated—give me 10 minutes, then I’ll come back better.”",
                "“Closure matters, but your safety matters more.”",
                "“That was too sharp. I’ll help you feel safe again.”",
                "“Let’s pause. I don’t want to damage us to solve us.”"
            ],
            repairProtocol: [
                "1) 10-min cooldown declaration",
                "2) No-weapon mode (no past / no weak spots)",
                "3) Reconnect line: “Safety first.”",
                "4) Apology + aftercare time"
            ],
            growthPath: "Speed is skill only when you can stop on command. The cooldown habit prevents collisions.",
            loveInsight:
                "Speed advances relationships—but unmanaged speed totals them."
        },

        6: {
            title: "The High-Sensitivity Sensor",
            summary: "High-resolution nervous system—overload triggers ‘forced low-power mode’",
            analysis: `You register sensory and emotional input at high fidelity. You notice tiny shifts, micro-tones, and environmental discomforts that others ignore. That sensitivity can be a relational superpower—until your battery drains. 
      Under overload, you don’t become cold by choice; your system protects itself by reducing output: fewer words, flatter expression, less capacity. Partners often misread this as boredom or loss of love.`,
            triggerMap: [
                "Noisy/crowded places, chaotic schedules",
                "Long travel days or back-to-back social events",
                "High stimulation + low sleep/hunger"
            ],
            innerMonologue: [
                "“Too much input… I can’t process more.”",
                "“I don’t have energy to explain right now.”",
                "“If I keep going, I’ll crash.”"
            ],
            relationshipLoop:
                "Stimulus accumulates → shutdown/quiet → partner interprets personally → partner demands reassurance → system overload increases → bigger conflict",
            whatYouNeed: [
                "Low-stimulus design (route + rest blocks)",
                "Battery disclosure at ~20%",
                "A recovery ritual that you treat as non-negotiable"
            ],
            whatPartnerNeeds: [
                "A clear explanation that it’s not about them",
                "Permission to rest without punishment",
                "A reliable reconnection signal (“I’ll be back after reset”)"
            ],
            doDont: {
                do: [
                    "Name overload early and request a reset",
                    "Insert planned sensory rest into dates",
                    "Reconnect intentionally after rest (touch, eye contact, short talk)"
                ],
                dont: [
                    "Endure in silence until you collapse",
                    "Blame yourself harshly for needing rest",
                    "Disappear without a return time"
                ]
            },
            scripts: [
                "“I’m overloaded—can we take a quiet reset?”",
                "“Not you. Too much input. I’ll be okay after a short break.”",
                "“If we plan rest blocks, I can enjoy longer.”",
                "“Give me 15 minutes—then I’m back with you.”"
            ],
            repairProtocol: [
                "1) Battery alert at 20%",
                "2) Low-stimulus reset (quiet spot / short walk / water)",
                "3) Prevent misread: “Not boredom—overload.”",
                "4) Promise reconnection: “15 minutes, then I’m back.”"
            ],
            growthPath: "Sensitivity is high performance. Share your user manual and it becomes intimacy, not conflict.",
            loveInsight:
                "You’re not broken—you’re high-resolution. High performance requires power management."
        },

        7: {
            title: "The Cold Sniper",
            summary: "Anger becomes precision logic—winning the argument can sink the relationship",
            analysis: `Your anger routes into language and logic. You don’t need to raise your voice to dominate a conflict—your accuracy does it. You spot contradictions, evasions, and weak reasoning instantly. 
      The risk: conflict becomes a verdict. Your partner can feel dissected rather than understood. Even if you’re right, the emotional cost can be massive, and repeated ‘losses’ teach your partner to shut down.`,
            triggerMap: [
                "Contradictions and story changes",
                "Evasion of responsibility",
                "Dishonesty or hidden information",
                "Illogical leaps that waste time"
            ],
            innerMonologue: [
                "“That doesn’t add up.”",
                "“Let’s get the facts straight.”",
                "“Stop dodging—own it.”"
            ],
            relationshipLoop:
                "Partner expresses emotion → you counter with logic → partner feels judged → shutdown or escalation → you sharpen further → safety collapses",
            whatYouNeed: [
                "A reminder: the goal is safety, not victory",
                "A mandatory empathy buffer (one line)",
                "Rules against identity/past/weak-spot attacks"
            ],
            whatPartnerNeeds: [
                "A safe tone, not a courtroom",
                "Permission to be messy without punishment",
                "Validation before critique"
            ],
            doDont: {
                do: [
                    "Say your intention: “I’m trying to protect us, not win.”",
                    "Validate first, then critique",
                    "Focus on today’s issue only"
                ],
                dont: [
                    "Use past mistakes as ammunition",
                    "Crush self-esteem with ‘efficient words’",
                    "Trap them with gotchas until they go silent"
                ]
            },
            scripts: [
                "“I care more about your safety than being right.”",
                "“That must have hurt. Can I share my side after that?”",
                "“Let’s keep this about today—no past weapons.”",
                "“I’m noticing contradictions, but I’ll say it gently.”"
            ],
            repairProtocol: [
                "1) Mandatory validation before critique",
                "2) Declare goal: safety, not winning",
                "3) Today-only rule (no past weapons)",
                "4) End with safety check: “Did this feel safe?”"
            ],
            growthPath: "Use precision as a map, not a blade. One validation line changes everything.",
            loveInsight:
                "Facts can be correct—and still be delivered in a way that breaks love."
        },

        8: {
            title: "The Dramatic Rollercoaster",
            summary: "Extreme emotional amplitude + fast resets—timing mismatch causes ‘emotional whiplash’",
            analysis: `Your emotional peaks are high and transitions are fast. You can go from rage to affection quickly, which feels freeing to you. To your partner, it can feel like whiplash: they’re still in shock while you’re already smiling. 
      Over time, this speed mismatch creates exhaustion. Partners begin to anticipate turbulence and seek distance for safety.`,
            triggerMap: [
                "Feeling ignored or dismissed",
                "Expectation mismatch",
                "Fatigue + stimulation + unresolved tension",
                "Small cues interpreted as big threats"
            ],
            innerMonologue: [
                "“This is unbearable right now!”",
                "“Wait… I’m okay again.”",
                "“Why can’t we just move on?”"
            ],
            relationshipLoop:
                "Spike → blow-up → quick reset → partner still injured → partner withdraws → you spike again at distance",
            whatYouNeed: [
                "Peak attenuation tools (breath/count/pause)",
                "Respect for partner’s slower recovery",
                "Aftercare as a ritual, not an afterthought"
            ],
            whatPartnerNeeds: [
                "Predictability and gentler amplitude",
                "Time to recover without being pressured",
                "Reassurance that the storm won’t repeat instantly"
            ],
            doDont: {
                do: [
                    "Pause before peak (10-second rule)",
                    "Apologize + provide recovery time",
                    "Say: “My reset is faster than yours—and that’s okay.”"
                ],
                dont: [
                    "Say “I’m over it, why aren’t you?” (ban)",
                    "Apologize then act like nothing happened",
                    "Blame them for still being hurt"
                ]
            },
            scripts: [
                "“I’ve calmed down, but you might not have—take your time.”",
                "“That was too much. I’ll help you feel safe again.”",
                "“We don’t have to solve it now. Let’s stabilize first.”",
                "“My emotions shift fast. I’ll slow down for you.”"
            ],
            repairProtocol: [
                "1) Attenuate peak (10-second breath/count)",
                "2) Apologize fast, no excuses",
                "3) Sync timing: “I may be calm; you may not be.”",
                "4) Offer recovery time and schedule reconnection"
            ],
            growthPath: "Your intensity is fuel. Reduce amplitude slightly and match recovery speed to turn drama into romance.",
            loveInsight:
                "Lightning passes quickly—but scars can remain."
        },

        9: {
            title: "The Frozen Volcano",
            summary: "Suppressed pressure—calm outside, loaded inside; small triggers can cause big eruptions",
            analysis: `You’re not calm because nothing bothers you. You’re calm because you’re trained to suppress output. That works—until it doesn’t. 
      When pressure builds with no release, the system looks stable right up until a small trigger detonates the whole load. Partners fear the mismatch: “Why is this tiny thing causing a huge explosion?”`,
            triggerMap: [
                "Repeated small disrespect or dismissals",
                "Detail-based triggers (tone, habits, orderliness)",
                "Accumulated fatigue and stress without rest",
                "Feeling unseen for too long"
            ],
            innerMonologue: [
                "“Let it go… again.”",
                "“This keeps happening.”",
                "“I’m at my limit.”"
            ],
            relationshipLoop:
                "Suppression → accumulation → sudden eruption → guilt/shutdown → suppression again → repeat",
            whatYouNeed: [
                "A safety valve habit (small releases twice a week)",
                "Lower-intensity naming (uncomfortable before angry)",
                "Trigger mapping and pre-agreements"
            ],
            whatPartnerNeeds: [
                "Predictability (early signals)",
                "Small corrections instead of surprises",
                "Reassurance that eruptions aren’t ‘random’"
            ],
            doDont: {
                do: [
                    "Speak at ‘uncomfortable’ stage",
                    "Schedule micro-check-ins",
                    "Rest and reset before you overflow"
                ],
                dont: [
                    "Endure silently until it detonates",
                    "Explain after the eruption as the only repair",
                    "Attack yourself with shame afterward"
                ]
            },
            scripts: [
                "“I’m not angry yet—just uncomfortable. Can we adjust this?”",
                "“I build up and burst, so I’m saying it early.”",
                "“Small talk now prevents big explosions later.”",
                "“I need a reset before I can talk calmly.”"
            ],
            repairProtocol: [
                "1) Early signal: “I’m building up.”",
                "2) Speak at ‘uncomfortable’ stage (not angry)",
                "3) One small request: “Can you change X?”",
                "4) Reset + Reassurance: “I’m okay now.”"
            ],
            growthPath: "Replace suppression with regulated release. You become one of the most stable partners possible.",
            loveInsight:
                "Endurance can be accumulation. Small releases prevent catastrophic eruptions."
        },

        10: {
            title: "The Glass Fixer",
            summary: "Deeply affected, yet repairs first—devotion that burns you out quietly",
            analysis: `You feel impact strongly, but your rescue reflex is stronger: when the relationship shakes, you move to stabilize it—even if you’re bleeding inside. 
      That makes you seem angelic, dependable, and endlessly forgiving. The cost: your partner leans more, you carry more, and eventually you deplete. When you finally shut down, it looks like a sudden personality change to them.`,
            triggerMap: [
                "Any sign of relational rupture",
                "Partner distress or instability",
                "Fear of abandonment or ‘losing the bond’"
            ],
            innerMonologue: [
                "“Fix it first. Feel later.”",
                "“If I hold it together, we survive.”",
                "“It’s my fault. I should’ve done better.”"
            ],
            relationshipLoop:
                "You repair/mediate → short-term stability → you deplete privately → sudden burnout → partner feels confused/betrayed → cycle repeats",
            whatYouNeed: [
                "Confess before fixing (state-first rule)",
                "Load-sharing agreements (stop being the sole stabilizer)",
                "Mandatory recovery windows after conflict"
            ],
            whatPartnerNeeds: [
                "To hear that you’re hurting too",
                "A shared responsibility structure",
                "A clear boundary: you are not an infinite resource"
            ],
            doDont: {
                do: [
                    "Say your state before you rescue",
                    "Ask for shared action (“Can we do this together?”)",
                    "Schedule recovery time as non-negotiable"
                ],
                dont: [
                    "Carry everything while saying ‘I’m fine’",
                    "Become the permanent mediator/parent",
                    "Disappear only after you fully break"
                ]
            },
            scripts: [
                "“I’m hurt too. Let’s repair this together.”",
                "“If I carry it all, I’ll crash. Can we share the work?”",
                "“I need 30 minutes to reset, then I’ll rejoin the talk.”",
                "“I want us, but I also need to protect my battery.”"
            ],
            repairProtocol: [
                "1) State disclosure: “I’m hurt too.”",
                "2) Split roles: “This is yours, this is mine.”",
                "3) Recovery window: “I need 30 mins to reset.”",
                "4) Reconnect gently (touch/eye contact/short reassurance)"
            ],
            growthPath: "Devotion matures when you learn to protect yourself while loving. Self-sacrifice is not the only proof of love.",
            loveInsight:
                "If you repair a sinking ship alone, you eventually go down with it."
        },

        11: {
            title: "The Bystander",
            summary: "Detachment-first conflict response—your peace can become your partner’s isolation",
            analysis: `Under emotional intensity, your system defaults to distance. It prevents escalation and protects your nervous system. But in relationships, absence communicates something: “You’re alone.” 
      You may think you’re being calm. Your partner experiences it as disengagement. Over time, they stop expressing emotions because it feels pointless.`,
            triggerMap: [
                "High-volume emotional conflict",
                "Demands for immediate emotional engagement",
                "Feeling flooded by someone else’s intensity"
            ],
            innerMonologue: [
                "“Why is this so extreme?”",
                "“If I engage now, it’ll get worse.”",
                "“I just want silence.”"
            ],
            relationshipLoop:
                "Partner escalates → you detach/withdraw → partner feels abandoned → escalates more → you detach further → emotional bond thins",
            whatYouNeed: [
                "Presence-signal skills (without fixing)",
                "Time-bound pauses (leave, but return at a set time)",
                "Acknowledging impact (“This affects me too”)"
            ],
            whatPartnerNeeds: [
                "A sign you’re still with them",
                "Small responses (nod, touch, one sentence)",
                "A guaranteed reconnection time"
            ],
            doDont: {
                do: [
                    "Say: “I’m here, even if I can’t solve it yet.”",
                    "Set a return time if you pause",
                    "Validate their emotion in one line"
                ],
                dont: [
                    "Silent vanishing",
                    "Treating emotion as noise to be ignored",
                    "Making them chase you for engagement"
                ]
            },
            scripts: [
                "“I can’t fix it instantly, but I won’t leave you alone in it.”",
                "“Your anger affects me too—I’m staying present.”",
                "“I need a pause. Let’s resume at 10pm.”",
                "“I’m listening. I may be quiet, but I’m here.”"
            ],
            repairProtocol: [
                "1) Presence signal",
                "2) Time-bound pause if needed",
                "3) One validation line",
                "4) Reconnect with one concrete next step"
            ],
            growthPath:
                "Detachment becomes healthy when it’s structured: pause with a return time, not disappearance.",
            loveInsight:
                "Not fighting doesn’t always protect love. Presence in discomfort often protects it better."
        },

        12: {
            title: "The Strategic Endurer",
            summary: "High-control emotional regulation—polished stability can be misread as ‘fake’",
            analysis: `You feel emotions, but you regulate output through a cost-benefit filter. You avoid messy escalation and keep your tone clean. This makes you stable and competent in conflict. 
      The shadow side: partners crave signs of humanity—small messiness, vulnerability, uncalculated honesty. If you’re always perfect, intimacy can feel like operations rather than love.`,
            triggerMap: [
                "Fights that feel inefficient or pointless",
                "High emotional consumption demands",
                "Partners pushing for immediate raw expression"
            ],
            innerMonologue: [
                "“If I react, I lose.”",
                "“Manage it. Keep it clean.”",
                "“This is emotional waste.”"
            ],
            relationshipLoop:
                "You stay composed → partner doubts your sincerity → partner escalates to ‘force’ emotion → you regulate harder → distance grows",
            whatYouNeed: [
                "A ‘5% rawness’ rule (small unfiltered emotion)",
                "Naming your motive (“I regulate to protect us”)",
                "Practicing acceptance before rebuttal"
            ],
            whatPartnerNeeds: [
                "Visible vulnerability and warmth",
                "Permission to be messy without being corrected",
                "Emotional presence, not just managerial calm"
            ],
            doDont: {
                do: [
                    "Offer one honest feeling without a solution",
                    "Say why you regulate (care, not control)",
                    "Let their emotion land before you respond logically"
                ],
                dont: [
                    "Be perfect all the time",
                    "Lead with rebuttals/corrections",
                    "Turn the relationship into a system of optimization"
                ]
            },
            scripts: [
                "“I’m not managing you—I’m regulating to protect us.”",
                "“Today I’ll just say it: I felt hurt. No calculations.”",
                "“Your feelings first. My logic can wait.”",
                "“I want to be closer, not just stable.”"
            ],
            repairProtocol: [
                "1) Share one raw feeling",
                "2) Name motive (care/protection)",
                "3) Validate partner emotion",
                "4) Agree on one small change"
            ],
            growthPath:
                "You become deeply lovable when you allow controlled imperfection—vulnerability is the shortcut to intimacy.",
            loveInsight:
                "Stability is valuable. Intimacy deepens when you sometimes put the calculator down."
        }
    }
};
